import { Box, Tooltip, Typography } from '@mui/material';
import InfoIcon from 'assets/icons-v2/InfoIcon';

type SoftwareImageVersionInfoProps = {
  dbServer: {
    engineType?: string;
    machineType?: string;
    osInfo?: {
      type?: string;
      image?: string;
    };
    metadata?: {
      dbserverInfo?: {
        softwareImageInfo?: {
          version?: string;
        };
      };
    };
    softwareImageVersionId?: string | null;
  };
};

export const SoftwareImageVersionInfo = ({
  dbServer,
}: SoftwareImageVersionInfoProps) => {
  const version =
    dbServer?.metadata?.dbserverInfo?.softwareImageInfo?.version ||
    dbServer?.softwareImageVersionId ||
    'Not available';
  const osImage = dbServer?.osInfo?.image || 'Not available';
  const osType = dbServer?.osInfo?.type || 'Not available';
  const engine = dbServer?.engineType || 'Not available';
  const machineType = dbServer?.machineType || 'Not available';
  const tooltipRows = [
    { label: 'Software image version', value: version },
    { label: 'OS', value: osType },
    { label: 'OS image', value: osImage },
    { label: 'Engine', value: engine },
    { label: 'Machine type', value: machineType },
  ];

  return (
    <Tooltip
      arrow
      placement="right"
      title={
        <Box sx={{ minWidth: 260 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
            DB server details
          </Typography>
          <Box sx={{ mt: 0.5 }}>
            {tooltipRows.map((row) => (
              <Typography variant="body2" key={row.label}>
                <strong>{row.label}:</strong> {row.value}
              </Typography>
            ))}
          </Box>
        </Box>
      }
    >
      <Box component="span" sx={{ ml: 0.5, display: 'inline-flex', cursor: 'default' }}>
        <InfoIcon width={16} height={16} monotone />
      </Box>
    </Tooltip>
  );
};

